<div class="info-outlet-wrapper">
    <div class="d-flex justify-content-center" [ngClass]="{'info-outlet-warning': type === 'warning'}">
        <span class="ml-2" [ngClass]="{'text-muted': type === 'info'}">{{title | translate}}</span>
    </div>
</div>
